/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MarkAsPatientRequest } from '../models/MarkAsPatientRequest';
import type { SignupPersonResponse } from '../models/SignupPersonResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PatientsService {
    /**
     * Sign up a new person.
     * Handles the registration of a new person in the system by providing their unique identifier.
     * @param id
     * @returns SignupPersonResponse The person has been signed up successfully.
     * @throws ApiError
     */
    public static signupPersonEndpoint(
        id: string,
    ): CancelablePromise<SignupPersonResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/persons/{id}/signup',
            path: {
                'id': id,
            },
            errors: {
                400: `The provided data is invalid or incomplete.`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `A person with the given ID already exists.`,
            },
        });
    }
    /**
     * Mark a person as a patient.
     * Marks a person as a patient by assigning SIME and TARV codes based on the provided ID.
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static markAsPatientEndpoint(
        id: string,
        requestBody: MarkAsPatientRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/persons/{id}/mark-as-patient',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid data provided in the request.`,
                401: `The user is not authorized to perform this action.`,
                403: `Forbidden`,
                404: `The specified ID was not found.`,
            },
        });
    }
}
